module.exports = __webpack_public_path__ + "img/delivery-4.b1ae4973.svg";